import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import Navbar          from './components/Navbar';
import Footer          from './components/Footer';
import Home            from './pages/Home';
import BooksPage       from './pages/BooksPage';
import BookDetail      from './pages/BookDetail';
import ReadChapter     from './pages/ReadChapter';
import Login           from './pages/Login';
import Register        from './pages/Register';
import Dashboard       from './pages/Dashboard';
import AdminPanel      from './pages/admin/AdminPanel';
import AdminBooks      from './pages/admin/AdminBooks';
import AdminAddBook    from './pages/admin/AdminAddBook';
import AdminEditBook   from './pages/admin/AdminEditBook';
import AdminChapters   from './pages/admin/AdminChapters';
import AdminUsers      from './pages/admin/AdminUsers';

const Guard = ({ children, adminOnly }) => {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <div className="spinner" style={{ marginTop: 120 }} />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  return children;
};

function AppRoutes() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/"          element={<Home />} />
        <Route path="/books"     element={<BooksPage />} />
        <Route path="/books/:id" element={<BookDetail />} />
        <Route path="/books/:bookId/chapters/:chapterId"
               element={<Guard><ReadChapter /></Guard>} />
        <Route path="/login"    element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Guard><Dashboard /></Guard>} />

        <Route path="/admin"                       element={<Guard adminOnly><AdminPanel /></Guard>} />
        <Route path="/admin/books"                 element={<Guard adminOnly><AdminBooks /></Guard>} />
        <Route path="/admin/books/new"             element={<Guard adminOnly><AdminAddBook /></Guard>} />
        <Route path="/admin/books/:id/edit"        element={<Guard adminOnly><AdminEditBook /></Guard>} />
        <Route path="/admin/books/:id/chapters"    element={<Guard adminOnly><AdminChapters /></Guard>} />
        <Route path="/admin/users"                 element={<Guard adminOnly><AdminUsers /></Guard>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default function App() {
  return <AuthProvider><AppRoutes /></AuthProvider>;
}
